import { required } from '@widergy/web-utils/lib/validate';
import { normalizeNumberWithDecimalsInput, normalizeDate } from '@widergy/web-utils/lib/normalize';

import * as FORMS_CONSTANTS from 'constants/userForms';
import { message } from 'utils/stringUtils';

const typeMapper = {
  [FORMS_CONSTANTS.RADIO]: FORMS_CONSTANTS.FIELD_RADIO,
  [FORMS_CONSTANTS.DATE]: FORMS_CONSTANTS.FIELD_TEXT,
  [FORMS_CONSTANTS.NUMBER]: FORMS_CONSTANTS.FIELD_TEXT
};

const normalizeMapper = {
  [FORMS_CONSTANTS.DATE]: normalizeDate,
  [FORMS_CONSTANTS.NUMBER]: normalizeNumberWithDecimalsInput
};

const questionMapper = question => ({
  id: question.id,
  type: typeMapper[question.field_type],
  order: question.order,
  title: question.question,
  key: question.question,
  field_options: Object.values(question.answers || []).map((answer, index) => ({
    id: index,
    value: answer,
    name: answer,
    order: index
  })),
  validate: [required(message('Translation:fieldRequired'))],
  normalize: normalizeMapper[question.field_type]
});

export default questionMapper;
